module.exports = __webpack_public_path__ + "static/media/056-malaysia.7da9df6b.svg";